export default "__VITE_ASSET__CHqsX3g3__"